export default __webpack_public_path__ + "static/media/bg4.7466a20d.jpg";